// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"price_wrapper__3uFOu","subTitle":"price_subTitle__pAc5E","left":"price_left__7cR2U","price":"price_price__s_Ofi","item":"price_item__vZ9XJ"};